import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Slide from "@material-ui/core/Slide";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import MenuItem from "@material-ui/core/MenuItem";
import _ from "lodash";

// Local Modules
import Snackbar from "./Snackbar";

// Icons
import AddIcon from "@material-ui/icons/Add";
import SettingsIcon from "@material-ui/icons/Settings";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = (theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing.unit,
    top: 17,
    color: "#FFF",
  },
  topLegent: {
    marginTop: 15,
    color: "rgba(0, 0, 0, 0.5)",
  },
  divider: {
    marginTop: 15,
    marginBottom: 10,
  },
  inputsContainer: {
    display: "flex",
    alignItems: "center",
  },
  addPhoneBtn: {
    marginLeft: 15,
    marginTop: 7,
  },
});

@observer
class SMSDialog extends Component {
  state = {
    textmask: "",
    textbox: "",
    defaultPhone: "",
  };

  render() {
    const {
      isOpen,
      phones,
      classes,
      textbox,
      sendSMS,
      chaseObj,
      phoneToAdd,
      setMessage,
      feedbackMsg,
      setFeedback,
      handleClose,
      defaultPhone,
      addPhoneOpen,
      addPhoneNumber,
      toggleAddNumber,
      setDefaultPhone,
    } = this.props;

    return (
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={isOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          <Typography variant="h6">
            SEND SMS TO {_.get(chaseObj, "Agent", "")}
          </Typography>
          <IconButton
            aria-label="Settings"
            className={classes.closeButton}
            onClick={() => toggleAddNumber()}
          >
            <SettingsIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {feedbackMsg !== "" && (
              <Snackbar
                variant={
                  feedbackMsg !== "something went wrong, sms was not sent"
                    ? "success"
                    : "error"
                }
                message={feedbackMsg}
                onClose={() => {
                  setFeedback("");
                }}
              />
            )}

            {addPhoneOpen && (
              <React.Fragment>
                <Typography className={classes.topLegent}>
                  When you add a phone number will be add as default and active.
                </Typography>
                <div className={classes.inputsContainer}>
                  <TextField
                    id="formatted-text-mask-input-phone"
                    label="Mobile phone number"
                    fullWidth={true}
                    margin="normal"
                    variant="outlined"
                    onChange={this.handlePhoneChange("textmask")}
                    value={phoneToAdd}
                  />
                  <IconButton
                    color="primary"
                    component="span"
                    variant="outlined"
                    className={classes.addPhoneBtn}
                    onClick={() => {
                      addPhoneNumber(chaseObj);
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                </div>
                <Divider variant="fullWidth" className={classes.divider} />
              </React.Fragment>
            )}

            {!_.isEmpty(phones) && (
              <FormControl variant="outlined" fullWidth margin="normal">
                <InputLabel
                  ref={(ref) => {
                    this.InputLabelRef = ref;
                  }}
                  htmlFor="outlined-age-simple"
                >
                  Mobile phone number
                </InputLabel>
                <Select
                  onChange={(evt) => {
                    setDefaultPhone(evt.target.value, true);
                  }}
                  value={defaultPhone}
                  input={
                    <OutlinedInput
                      placeholder="Mobile phone number"
                      name="phones"
                      fullWidth={true}
                      id="outlined-age-simple"
                    />
                  }
                >
                  {_.map(phones, (item, i) => {
                    return (
                      <MenuItem value={item.phone} key={`${item.phone}-${i}`}>
                        {this.formatPhoneNumber(1 + item.phone)}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            )}
            <TextField
              id="outlined-multiline-static"
              label="Your message... "
              multiline
              rows="4"
              value={textbox}
              onChange={(evt) => setMessage(evt.target.value)}
              fullWidth={true}
              margin="normal"
              variant="outlined"
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose()} color="primary">
            CLOSE
          </Button>
          <Button
            disabled={textbox === "" || defaultPhone === ""}
            onClick={() => {
              sendSMS();
            }}
            color="primary"
          >
            SEND
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  formatPhoneNumber(phoneNumberString) {
    const cleaned = ("" + phoneNumberString)
      .replace(/\D/g, "")
      .substring(0, 11);
    let formated = "";
    if (_.size(cleaned) > 7) {
      formated = `+${cleaned.substring(0, 1)} (${cleaned.substring(
        1,
        4
      )}) ${cleaned.substring(4, 7)} - ${cleaned.substring(7, 11)}`;
    } else if (_.size(cleaned) > 4) {
      formated = `+${cleaned.substring(0, 1)} (${cleaned.substring(
        1,
        4
      )}) ${cleaned.substring(4, 7)}`;
    } else if (_.size(cleaned) > 1) {
      formated = `+${cleaned.substring(0, 1)} (${cleaned.substring(1, 4)}`;
    } else if (_.size(cleaned) > 0) {
      formated = `+${cleaned.substring(0, 1)}`;
    }
    return formated;
  }

  handlePhoneChange = (name) => (event) => {
    const phoneNumber = this.formatPhoneNumber(event.target.value);
    this.props.setDefaultPhone(phoneNumber);
  };
}

SMSDialog.propTypes = {
  isOpen: PropTypes.func,
  chaseObj: PropTypes.object,
  handleClose: PropTypes.func,
  phones: PropTypes.array,
  defaultPhone: PropTypes.string,
  setDefaultPhone: PropTypes.string,
  setMessage: PropTypes.func,
  textbox: PropTypes.string,
  sendSMS: PropTypes.func,
  feedbackMsg: PropTypes.string,
  setFeedback: PropTypes.func,
};

export default withStyles(styles)(SMSDialog);
